import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "ml-1"
};
import ValidationIndicator from "@/components/ValidationIndicator.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EquifaxDigitalIdentityTrustIndicator',
    props: {
        check: {},
        category: {},
        label: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_ctx.check)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!_ctx.check[_ctx.category].verified)
                        ? (_openBlock(), _createBlock(ValidationIndicator, {
                            key: 0,
                            type: "error",
                            label: "INVALID",
                            tooltip: `Equifax Digital Identity Trust - ${_ctx.label} appears to be invalid`
                        }, null, 8, ["tooltip"]))
                        : (!_ctx.check[_ctx.category].matched)
                            ? (_openBlock(), _createBlock(ValidationIndicator, {
                                key: 1,
                                type: "warning",
                                label: "UNMATCHED",
                                tooltip: `Equifax Digital Identity Trust - ${_ctx.label} could not be matched with the citizen's identity`
                            }, null, 8, ["tooltip"]))
                            : (!_ctx.check[_ctx.category].trusted)
                                ? (_openBlock(), _createBlock(ValidationIndicator, {
                                    key: 2,
                                    type: "success",
                                    label: "MATCHED",
                                    tooltip: `Equifax Digital Identity Trust - ${_ctx.label} is matched`
                                }, null, 8, ["tooltip"]))
                                : (_openBlock(), _createBlock(ValidationIndicator, {
                                    key: 3,
                                    type: "success",
                                    label: "TRUSTED",
                                    tooltip: `Equifax Digital Identity Trust - ${_ctx.label} is trusted`
                                }, null, 8, ["tooltip"]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
